import styled from "styled-components"

export const ContentfulLPContentDIV = styled.div`
  display: block;
`
